import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import DekalioCustomizer from './components/DekalioCustomizer/DekalioCustomizer';
import Landing from './components/Landing/LandingModern';
import NotFound from './components/NotFound/NotFound';
import { CartProvider, useCart } from './context/CartContext';
import { Toaster } from 'react-hot-toast';
import PaymentSuccess from './components/Checkout/PaymentSuccess';
import CartPage from './components/Cart/CartPage';
import { initHotjar, initGA } from './utils/analytics';
import Cookies from './components/Pages/Cookies';
import CookieBanner from './components/common/CookieBanner';
import Privacy from './components/Pages/Privacy';
import Terms from './components/Pages/Terms';
import Support from './components/Pages/Support';
import About from './components/Pages/About';
import Contact from './components/Pages/Contact';
import FAQ from './components/Pages/FAQ';
import { PaymentSuccessPreview } from './components/Checkout/PaymentSuccess';
import FeedbackForm from './components/Feedback/FeedbackForm';

// Admin components
import AdminLogin from './components/Admin/AdminLogin';
import AdminDashboard from './components/Admin/AdminDashboard';
import AdminOrders from './components/Admin/AdminOrders';
import AdminOrderDetails from './components/Admin/AdminOrderDetails';
import ProtectedRoute from './components/Admin/ProtectedRoute';

// Create a wrapper component for AnimatePresence and cart cookie checking
const AnimatedRoutes = () => {
  const location = useLocation();
  const { clearCart } = useCart();

  // Check for cookie on every navigation
  useEffect(() => {
    const checkClearCartCookie = () => {
      const cookies = document.cookie.split(';');
      const clearCartCookie = cookies.find(cookie => cookie.trim().startsWith('dekalio_clear_cart='));
      
      if (clearCartCookie) {
        console.log('Found clear cart cookie, clearing cart...');
        clearCart();
        
        // Remove the cookie
        document.cookie = 'dekalio_clear_cart=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
      }
    };
    
    checkClearCartCookie();
  }, [location, clearCart]);

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        {/* Public routes */}
        <Route path="/" element={<Landing />} />
        <Route path="/customize" element={<DekalioCustomizer />} />
        <Route path="/cart" element={<CartPage />} />
        <Route path="/payment-success" element={<PaymentSuccess />} />
        <Route path="/cookies" element={<Cookies />} />
        <Route path="/integritetspolicy" element={<Privacy />} />
        <Route path="/villkor" element={<Terms />} />
        <Route path="/support" element={<Support />} />
        <Route path="/om-oss" element={<About />} />
        <Route path="/kontakt" element={<Contact />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/preview/payment-success" element={<PaymentSuccessPreview />} />
        
        {/* Admin routes */}
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/dashboard" element={
          <ProtectedRoute>
            <AdminDashboard />
          </ProtectedRoute>
        } />
        <Route path="/admin/orders" element={
          <ProtectedRoute>
            <AdminOrders />
          </ProtectedRoute>
        } />
        <Route path="/admin/orders/:orderId" element={
          <ProtectedRoute>
            <AdminOrderDetails />
          </ProtectedRoute>
        } />
        
        {/* Catch-all route */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </AnimatePresence>
  );
};

function App() {
  useEffect(() => {
    // Initialize analytics
    initHotjar();
    initGA();
  }, []);

  return (
    <CartProvider>
      <Router>
        <div className="App">
          <AnimatedRoutes />
          <Toaster />
          <CookieBanner />
          {/* <FeedbackForm /> */}
        </div>
      </Router>
    </CartProvider>
  );
}

export default App;